import React from "react";
import { Table, TableHead, TableRow, TableCell, TableBody, TableContainer } from "@mui/material";
import { DndContext, closestCenter } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { IniInfo } from "system/types/interfaces";
import { SortableConfigurationRow } from "./SortableConfigurationRow";

interface ConfiguredTableProps {
  configuredRules: IniInfo[];
  onAdd: (index: number) => void;
  onDelete: (id: string) => void;
  onUndoDelete: (id: string) => void;
  onEdit: (rule: IniInfo) => void;
  onToggleComment?: (id: string, isComment: boolean) => void;
  onReorder: (oldIndex: number, newIndex: number) => void;
  readOnlyViewer: boolean;
}

export const ConfiguredTable: React.FC<ConfiguredTableProps> = ({
  configuredRules,
  onAdd,
  onDelete,
  onUndoDelete,
  onEdit,
  onToggleComment,
  onReorder,
  readOnlyViewer,
}) => {
  const handleDragEnd = (event: any) => {
    const { active, over } = event;
    if (!over) return;
    if (active.id !== over.id) {
      const oldIndex = configuredRules.findIndex((item) => item.id === active.id);
      const newIndex = configuredRules.findIndex((item) => item.id === over.id);

      onReorder(oldIndex, newIndex);
    }
  };

  return (
    <TableContainer sx={{ backgroundColor: "#1b1a19", borderRadius: 2, marginBottom: 3 }}>
      <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext items={configuredRules.filter((item) => item.id).map((item) => item.id!)} strategy={verticalListSortingStrategy}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#333" }}>
                <TableCell sx={{ color: "#fff", width: "50px" }} />
                <TableCell sx={{ color: "#fff", width: "300px" }}>Rule</TableCell>
                <TableCell sx={{ color: "#fff" }}>Value</TableCell>
                <TableCell sx={{ color: "#fff" }}>Applicability</TableCell>
                <TableCell sx={{ color: "#fff", width: "250px" }} align="right">
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {configuredRules.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} sx={{ color: "#aaa", textAlign: "center" }}>
                    No configurations have been added yet.
                  </TableCell>
                </TableRow>
              ) : (
                configuredRules.map((line, index) => (
                  <SortableConfigurationRow
                    key={line.id}
                    item={line}
                    index={index}
                    onAdd={onAdd}
                    onDelete={onDelete}
                    onUndoDelete={onUndoDelete}
                    onEdit={onEdit}
                    onToggleComment={onToggleComment}
                    readOnlyViewer={readOnlyViewer}
                  />
                ))
              )}
            </TableBody>
          </Table>
        </SortableContext>
      </DndContext>
    </TableContainer>
  );
};
